import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar-style-two',
  templateUrl: './navbar-style-two.component.html',
  styleUrls: ['./navbar-style-two.component.scss']
})
export class NavbarStyleTwoComponent implements OnInit {
  languages = [
    { code: 'en', name: 'English', flag: 'us' },
    { code: 'fr', name: 'French', flag: 'fr' },
    { code: 'es', name: 'Spanish', flag: 'es' },
    { code: 'pt', name: 'Portuguese', flag: 'pt' }
  ];
  selectedLanguage: string = 'en';
  selectedLanguageName: string = 'English';
  selectedFlag: string = 'us';
  constructor(private router: Router) { }

  ngOnInit(): void {
    const savedLang = localStorage.getItem('selectedLanguage');
    const savedFlag = localStorage.getItem('selectedFlag');
    const savedLangName = localStorage.getItem('selectedLanguageName');

    if (savedLang && savedFlag && savedLangName) {
      this.selectedLanguage = savedLang;
      this.selectedFlag = savedFlag;
      this.selectedLanguageName = savedLangName;
    }
  }

  changeLanguage(lang: any) {
    this.selectedLanguage = lang.code;
    this.selectedFlag = lang.flag;
    this.selectedLanguageName = lang.name;

    localStorage.setItem('selectedLanguage', lang.code);
    localStorage.setItem('selectedFlag', lang.flag);
    localStorage.setItem('selectedLanguageName', lang.name);
    sessionStorage.setItem('languageflag',lang.flag)

    // if (['en', 'fr', 'es', 'pt'].includes(this.selectedLanguage)) {
    //   window.location.href = `http://localhost:4000/${this.selectedLanguage}/`;
    // }

    // if(lang.code=='en'){
    //   window.location.href = `http://localhost:4000/${lang.code}/`;
    // }
    // else if(lang.code=='fr'){
    //   window.location.href = `http://localhost:4000/${lang.code}/`;
    // }
    // else if(lang.code=='es'){
    //   window.location.href = `http://localhost:4000/${lang.code}/`;
    // }
    // else if(lang.code=='pt'){
    //   window.location.href = `http://localhost:4000/${lang.code}/`;
    // }
    const allowedLanguages = ['en', 'fr', 'es', 'pt'];

    if (allowedLanguages.includes(lang.code)) {
        let url = new URL(window.location.href);  // Get the full URL
        let pathSegments = url.pathname.split('/').filter(segment => segment !== ""); // Split path and remove empty parts

        // Remove existing language code if present
        if (allowedLanguages.includes(pathSegments[0])) {
            pathSegments.shift();  // Remove the first segment if it's a language code
        }

        // Add the new language code at the beginning
        pathSegments.unshift(lang.code);

        // Construct the new URL
        url.pathname = '/' + pathSegments.join('/') + '/';

        // Redirect to the new URL
        window.location.href = url.toString();
    }
  }
}
